import { FC, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { LanguagesCode } from 'src/i18n/constants';
import { initI18Next } from 'src/i18n/instance';
import { Routing } from 'src/layout';
import { Layout } from 'src/layout/layout';
import { PaymentPlanDto } from 'src/api/paymentPlanService/dto/PaymentPlanDto';
import { setBasket } from 'src/store/slices/basket-slice';
import { setDetails } from 'src/store/slices/user-slice';
import { setBookingDetails, setBuildingData, setRoomData } from 'src/store/slices/booking-slice';
import { setCreatedPaymentPlan, setUserChoices } from 'src/store/slices/payment-plan-slice';
import {
    getBasketStorage,
    getBookingStorage,
    getPaymentPlanSelectionStorage,
    getUserStorage,
} from 'src/utils/local-storage-versioning';

initI18Next(LanguagesCode.English);

export const App: FC = () => {
    const methods = useForm();
    const dispatch = useDispatch();

    useEffect(() => {
        const storedBasket = getBasketStorage();
        const bookingStorage = getBookingStorage();
        const paymentPlanSelectionStorage = getPaymentPlanSelectionStorage();
        const user = getUserStorage();

        if (storedBasket) {
            dispatch(setBasket(storedBasket));
        }

        if (bookingStorage) {
            const { room, details, building } = bookingStorage;

            if (room) {
                dispatch(setRoomData(room));
            }
            if (details) {
                dispatch(setBookingDetails(details));
            }
            if (building) {
                dispatch(setBuildingData(building));
            }
        }

        if (paymentPlanSelectionStorage) {
            const { createdPaymentPlan, userChoices } = paymentPlanSelectionStorage;
            dispatch(setCreatedPaymentPlan(new PaymentPlanDto(createdPaymentPlan)));
            dispatch(setUserChoices(userChoices));
        }

        if (user) {
            dispatch(setDetails(user));
        }
    }, []);

    return (
        <FormProvider {...methods}>
            <Layout>
                <Routing />
            </Layout>
        </FormProvider>
    );
};

export default App;
